function calculateVisibleHeaderHeight() {
    const elementsToWatch = [
        '.section-announcement-bar',
        '.section-top-bar'
    ];

    let totalVisibleHeight = 0;
    const visibilityStatus = {};
    const targetElement = document.querySelector('#CollectionSidebar');

    const observer = new IntersectionObserver((entries) => {
    
        entries.forEach(entry => {
            visibilityStatus[entry.target.className] = entry.isIntersecting;
            console.log(`${entry.target.className} visible status updated: ${entry.isIntersecting}`);
        });

        totalVisibleHeight = 0;

        const headerElement = document.querySelector('.section-header');
        if (headerElement) {
            const headerHeight = headerElement.offsetHeight;
            totalVisibleHeight += headerHeight;
            console.log(`Header height: ${headerHeight}px`);
        }
        elementsToWatch.forEach(selector => {
            const element = document.querySelector(selector);
            if (element) {
                const isVisible = visibilityStatus[element.className]; 
                
                if (isVisible) {
                    const height = element.offsetHeight;
                    totalVisibleHeight += height;
                    console.log(`✅ Included: ${element.className} height: ${height}px`);
                } else {
                    console.log(`❌ Skipped: ${element.className} is NOT intersecting.`);
                }
            }
        });
        if (targetElement) {
            targetElement.style.paddingTop = `${totalVisibleHeight}px`;
        }
        console.log(`\n**Total Combined Visible Height (IntersectionObserver): ${totalVisibleHeight}px**`);
    }, {
        root: null,
        threshold: 0.01
    });
    elementsToWatch.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            // set initial visibility status to false before start observing
            visibilityStatus[element.className] = false;
            observer.observe(element);
        }
    });
}
document.addEventListener('DOMContentLoaded', calculateVisibleHeaderHeight);